import { createSelectorHook, createDispatchHook } from 'react-redux';
export const useTimelineSelector = createSelectorHook();
export const useTimelineDispatch = createDispatchHook();